import { useQuery } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'
import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { toast } from '~/utils'

type SmsPreviewResponse = {
  content: string
}

export const useSmsPreview = (
  enabled: boolean,
  applicantIri: string | null,
  agencyIri?: string | null,
  template?: number | string | null,
  content?: string | null
) =>
  useQuery<SmsPreviewResponse>({
    queryKey: ['sms-preview', applicantIri, agencyIri, template, content],
    queryFn: async ({ signal }) => {
      try {
        return await fetchApiWithToken<SmsPreviewResponse>({
          method: 'post',
          url: '/v1/sms/preview',
          data: {
            ...(applicantIri ? { applicant: applicantIri } : {}),
            ...(agencyIri ? { agency: agencyIri } : {}),
            ...(template ? { template: String(template) } : {}),
            ...(content ? { content } : {})
          },
          signal
        })
      } catch (err) {
        if (
          (err as ApiResponseError)?.httpStatus === 422 ||
          (err as ApiResponseError)?.httpStatus === 403
        ) {
          const apiErr = err as ApiResponseError

          if (
            apiErr.response.message?.match(/Availability SMS is not enabled/)
          ) {
            toast(
              'Prévisualisation en erreur',
              'Le SMS de demande de disponibilité est désactivé.',
              ToastType.Danger
            )
          } else if (
            apiErr.response.message?.match(
              /No content provided for SMS preview./
            )
          ) {
            toast(
              'Prévisualisation en erreur',
              'Pas de contenu fourni pour la prévisualisation du SMS.',
              ToastType.Danger
            )
          } else if (
            apiErr.response.message?.match(
              /Not allowed to preview availability SMS for this agency./
            )
          ) {
            toast(
              'Prévisualisation en erreur',
              "Vous n'êtes pas autorisé à prévisualiser le SMS de demande de disponibilité pour cette agence.",
              ToastType.Danger
            )
          } else {
            toast(
              'Prévisualisation en erreur',
              'Une erreur inconnue est survenue.',
              ToastType.Danger
            )
          }
        }

        throw err
      }
    },
    enabled,
    retry: false,
    staleTime: 30_000
  })
